function ServiceSearchBar({
  value,
  onChange,
  placeholder = "Search services...",
  autoFocus = false,
}) {
  return (
    <div style={wrap}>
      <span style={icon}>🔎</span>
      <input
        autoFocus={autoFocus}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={input}
      />
    </div>
  );
}

const wrap = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  background: "#111",
  border: "1px solid #262626",
  borderRadius: "16px",
  padding: "12px 14px",
  boxShadow: "0 8px 20px rgba(0,0,0,0.18)",
};

const icon = {
  fontSize: "18px",
  lineHeight: 1,
};

const input = {
  width: "100%",
  border: "none",
  outline: "none",
  background: "transparent",
  color: "#fff",
  fontSize: "16px",
};

export default ServiceSearchBar;